<template>
  <div>
    <h3 class="header-title">Learning Broadcast</h3>
    <label>Let’s see your tuition broadcast.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your broadcast !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCol sm="12" class="mt-4">
        <CRow>
          <CCol sm="4">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
              @change="ApplyFilter()"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="3">
            <v-select
              v-model="selectedName"
              :options="nameOptions"
              label="Name"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="3">
            <v-select
              v-model="selectedView"
              :options="viewOptions"
              label="IsSeen"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="3"> </CCol>

          <CCol sm="3">
            <CButton
              class="custom-btn-success"
              type="button"
              @click="OpenFormBroadcast()"
              ><CIcon name="cil-plus" />Add Broadcast</CButton
            >
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="12">
        <!-- <CRow>
          <CCol sm="4">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
              @change="ApplyFilter()"
            />
          </CCol>
        </CRow> -->

        <CRow>
          <!-- <CCol sm="2">
            <v-select
              v-model="selectedName"
              :options="nameOptions"
              label="Name"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="2">
            <v-select
              v-model="selectedView"
              :options="viewOptions"
              label="IsSeen"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <CCol sm="5"> </CCol>

          <CCol sm="3">
            <CButton
              class="custom-btn-success"
              type="button"
              @click="OpenFormBroadcast()"
              ><CIcon name="cil-plus" />Add Broadcast</CButton
            >
          </CCol> -->
        </CRow>
      </CCol>
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="FilteredNoti"
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          clickable-rows
          sorter
          pagination
        >
          <template #Parent="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.Name }}
              </h6>
            </td>
          </template>

          <template #Message="{ item }">
            <td>
              {{ item.Description }}
            </td>
          </template>

          <template #Time="{ item }">
            <td>
              {{ item.CreatedTime | moment("DD/MM/YYYY HH:mm") }}
            </td>
          </template>

          <template #Viewed="{ item }">
            <td>
              <CBadge v-if="item.IsSeen === true" color="success"
                >Viewed</CBadge
              >
              <CBadge v-else color="danger">Not Viewed</CBadge>
            </td>
          </template>
        </CDataTable>
      </CCol>

      <CModal
        title="Add New Broadcast"
        size="lg"
        :show.sync="BroadcastModal"
        :close-on-backdrop="false"
        :close-on-esc="false"
      >
        <div>
          <h6><strong>FORM BROADCAST</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="3"> Title </CCol>
              <CCol sm="9">
                <CInput type="text" v-model="DataMessage" />
              </CCol>
              <CCol sm="3"> Description </CCol>
              <CCol sm="9">
                <CInput type="text" v-model="Description" />
              </CCol>
              <div style="clear: both"></div>
              <hr />
              <CCol sm="12">
                <CRow>
                  <CCol sm="3">
                    <v-select
                      v-model="selectedGrade"
                      :options="gradeOptions"
                      label="Class"
                      class="custom-btn-blue style-chooser"
                      @input="FilteredDataUser()"
                    ></v-select>
                  </CCol>
                  <CCol sm="3">
                    <v-select
                      v-model="selectedClass"
                      :options="classOptions"
                      label="Class"
                      class="custom-btn-blue style-chooser"
                      @input="FilteredDataUser()"
                    ></v-select>
                  </CCol>
                </CRow>
                <!-- <table
                  class="
                    table table-responsive-sm table-hover table-outline
                    mb-0
                    mt-2
                  "
                >
                  <thead>
                    <th>
                      <input
                        type="checkbox"
                        @click="checkAll()"
                        v-model="isCheckAll"
                      />
                    </th>
                    <th>Student Name</th>
                    <th>Parent Name</th>
                    <th>Grade</th>
                    <th>Class</th>
                    <th>Email</th>
                  </thead>
                  <tbody>
                    <tr v-for="item in FilteredUserList" v-bind:key="item.Id">
                      <td>
                        <input
                          type="checkbox"
                          id="checkbox"
                          v-model="item.isChecked"
                        />
                      </td>
                      <td>
                        {{ item.Name }}
                      </td>
                      <td>
                        {{ item.ParentName }}
                      </td>
                      <td>
                        {{ item.Grade }}
                      </td>
                      <td>
                        {{ item.Class }}
                      </td>
                      <td>
                        {{ item.Email }}
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                <br />
                <div>
                  <input
                        type="checkbox"
                        @click="checkAll()"
                        v-model="isCheckAll"
                      /> Select All Student
                </div>
                <CDataTable
                  :hover="hover"
                  :striped="striped"
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  :items="FilteredUserList"
                  :fields="fieldsBroadcast"
                  items-per-page-select
                  :items-per-page="small ? 5 : 10"
                  :dark="dark"
                  columnFilter
                  pagination
                >
                <input
                        type="checkbox"
                        @click="checkAll()"
                        v-model="isCheckAll"
                      /> Select All Student
                <template #Select="{ item }">
                    <td>
                      <input
                          type="checkbox"
                          id="checkbox"
                          v-model="item.isChecked"
                        />
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCol>
        </div>
        <template #footer>
          <CButton
            type="submit"
            class="p-2"
            color="info"
            @click="InsertBroadcast()"
            >Proceed</CButton
          ></template
        >
      </CModal>
    </div>
  </div>
</template>



<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      noti: [],
      FilteredNoti: [],
      SearchQuery: "",

      perPage: 10,
      pagination: {},
      currentPage: 1,

      selectedName: "ALL TEACHER",
      nameOptions: [],

      selectedView: "ALL VIEW",
      viewOptions: [],

      Busy: false,

      fields: [
        { key: "Parent" },
        { key: "Message" },
        { key: "Time" },
        { key: "Viewed" },
      ],
      fieldUserList: [
        { key: "Check" },
        { key: "Name" },
        { key: "ParentName" },
        { key: "Grade" },
        { key: "Class" },
        { key: "Email" },
      ],
      fieldsBroadcast: [
        { key: "Select" },
        { key: "Name" },
        { key: "ParentName" },
        { key: "Grade" },
        { key: "Class" },
        { key: "ParentEmail" },
      ],
      FilteredUserList: [],
      users: [],
      BroadcastModal: false,

      isCheckAll: false,
      DataMessage: "",
      Description: "",
      selectedGrade: "ALL GRADE",
      gradeOptions: [],

      selectedClass: "ALL CLASS",
      classOptions: [],
      small: "",
      fixed: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetNoti();
    } else {
      this.GoToLogin();
    }
  },

  async mounted() {
    this.GetNoti();
  },
  methods: {
    GetNoti() {
      this.Busy = true;
      this.$API
        .get(this.$ViewNotification, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.noti = response.data;
            this.FilteredNoti = this.noti;

            var parentNames = _.uniq(_.map(response.data, "Name"));
            parentNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.nameOptions = parentNames;
            this.nameOptions.unshift("ALL PARENT");

            var viewNames = _.uniq(_.map(response.data, "IsSeen"));
            this.viewOptions = viewNames;
            this.viewOptions.unshift("ALL VIEW");
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.noti, ["Description"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Description }) =>
          _.some([
            _.includes(!Description || Description.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredNoti = result;
      }
    },
    FilteredData() {
      console.log("masuk");
      this.FilteredNoti = this.noti;

      if (this.selectedName !== "ALL PARENT")
        this.FilteredNoti = _.filter(
          this.FilteredNoti,
          (item) => item.Name === this.selectedName
        );

      if (this.selectedView !== "ALL VIEW")
        this.FilteredNoti = _.filter(
          this.FilteredNoti,
          (item) => item.IsSeen === this.selectedView
        );

      // if (this.selectedTeacher !== "ALL TEACHER")
      //   this.FilteredAttendance = _.filter(
      //     this.FilteredAttendance,
      //     (item) => item.Teacher === this.selectedTeacher
      //   );
    },
    FilteredDataUser() {
      console.log("masuk");
      this.FilteredUserList = this.users;

      if (this.selectedGrade !== "ALL GRADE")
        this.FilteredUserList = _.filter(
          this.FilteredUserList,
          (item) => item.Grade === this.selectedGrade
        );

      if (this.selectedClass !== "ALL CLASS")
        this.FilteredUserList = _.filter(
          this.FilteredUserList,
          (item) => item.Class === this.selectedClass
        );
    },
    OpenFormBroadcast() {
      this.$API
        .get(this.$ViewStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.users = response.data;
            this.FilteredUserList = this.users;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var classNames = _.uniq(_.map(response.data, "Class"));
            classNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.classOptions = classNames;
            this.classOptions.unshift("ALL CLASS");
          }
        });

      this.BroadcastModal = true;
    },

    checkAll: function () {
      this.isCheckAll = !this.isCheckAll;
      var temp = this;
      this.users.forEach(function (item) {
        if (item.isChecked !== temp.isCheckAll) {
          item.isChecked = temp.isCheckAll;
        }
      });
    },
    InsertBroadcast() {
      const formData = new FormData();
      var combinedSubject = [];
      var count = 0;
      for (var index = 0; index < this.users.length; index++) {
            let pv = this.users[index];
            if (pv.isChecked) {
              // formData.append("userList[" + count + "]", pv.Id);
              // count++;

              let combinedItem = {
                userListId: pv.UserId,
            };
            combinedSubject.push(combinedItem);
          }
        }
    let subjectData = JSON.stringify(combinedSubject);
    formData.append("userList", subjectData);
      formData.append("DataMessage", this.DataMessage);
      formData.append("Description", this.Description);

      return this.$API
        .post(this.$InsertBroadcast, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.BroadcastModal = false;
            this.$dialog
              .alert("You have successfully send broadcast")
              .then(function () {});
            this.isCheckAll = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
.custom-btn-success {
  color: #fff;
  background-color: #2eb85c;
  border-color: #2eb85c;
  width: 230px;
}
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
</style>



